module.exports = __webpack_public_path__ + "img/inst-16.28ac9095.png";